// extracted by mini-css-extract-plugin
module.exports = {"bell":"Bell_bell__3wNUe","bellIcon":"Bell_bellIcon__2Gl35","bellIcon_info":"Bell_bellIcon_info__3jGv-","bellBadge":"Bell_bellBadge__1Gr4R"};